export const PROPERTY_APT_RESIDENT_en = {
  translation: {
    keys: {
      condominium: 'Property',
      handoverInstructions: 'Key handover instructions',
      handoverInstructionsPlaceholder: 'Write instructions for key handover and return',
    },
    key: {
      handoverAddFromDirectory: 'By property or apartment',
      handoverDirectoryHint:
        'Pick a property or apartment, or type at least two characters to search (stamp, address, property).',
      handoverDirectoryNoQuery: 'Select a property or apartment, or type at least 2 characters to search.',
    },
    apartments: {
      apartment: 'Apartment',
      condominium: 'Property',
      selectCondominium: 'Select property',
      condominiumRequired: 'Property is required',
    },
    validation: {
      condominiumRequired: 'Property is required',
    },
    wizard: {
      title: 'Quick property setup',
      subtitle: 'Create the property, apartments, residents and keys at once',
      steps: {
        condominium: 'Property',
      },
      stepDescriptions: {
        condominium: 'Create a new property by filling in the basic information',
        apartments: 'Add apartments to the property individually or in bulk',
      },
    },
    condominium: {
      header: 'Properties',
      condominiums: 'Properties',
      condominiumDetails: 'Property details',
      name: 'Property',
      create: 'Create property',
      edit: 'Edit property',
      update: 'Update property',
      deleteTitle: 'Delete property',
      deleteMessage: 'Are you sure you want to delete the property',
      searchPlaceholder: 'Search properties...',
      nocondominiumsForSearch: 'No properties found for "{{searchTerm}}"',
      nocondominiumsYet: 'No properties.',
      selectCondominium: 'Select a condominium',
      transfer: {
        toSubCompany: 'Transfer to sub company',
        transferredTooltip: 'Transferred to sub company',
        transferredTo: 'Transferred to {{name}}',
        subCompanyCanEdit: 'Sub company can edit transferred data',
        revokeTransfer: 'Revoke transfer',
        changeEditAccess: 'Change edit access',
        selectSubCompany: 'Select sub company',
        confirmTransfer: 'Confirm transfer',
        transferSuccess: 'Transfer completed',
        revokeConfirm:
          'Are you sure you want to revoke the transfer? The sub company will lose access to the property.',
        transferredAt: 'Transferred at',
        back: 'Back',
        next: 'Next',
      },
    },
    controlPanel: {
      transferredCondominiums: 'Transferred properties',
      personalDataPurge: {
        targetsHint: 'People are selected by default. Add properties, apartments, and keys when needed.',
        propertyGroupHint: 'Properties, apartments, and keys go to the same 7-day trash.',
        targetTypes: {
          condominium: 'Properties',
        },
        fields: {
          condominiumId: 'Property',
        },
        columns: {
          condominium: 'Property',
        },
      },
    },
    messages: {
      condominiumCreated: 'Property created successfully',
      condominiumUpdated: 'Property updated successfully',
      condominiumDeleted: 'Property deleted successfully',
      condominiumsDeletedBulk: '{{count}} properties deleted successfully',
      condominiumCreateFailed: 'Property creation failed',
      condominiumUpdateFailed: 'Property update failed',
      condominiumDeleteFailed: 'Property deletion failed',
    },
    dashboard: {
      myManagedProperties: 'Properties I manage',
      noProperties: 'No properties to display',
    },
    properties: {
      tabProperties: 'Properties',
      tabApartments: 'Apartments',
      createProperty: 'Create property',
    },
    general: {
      showBulkDelete: 'Show bulk delete in tables',
      showBulkDeleteDescription:
        'Enable selecting and deleting multiple items in apartments, residents, properties, and keys tables.',
    },
    actions: {
      bulk: {
        deleteCondominiumsMessage: 'Are you sure you want to delete {{count}} selected properties?',
        editCondominiumsTitle: 'Edit properties',
      },
    },
    tooltips: {
      keys: {
        handoverInstructions:
          'Shown during key handover and return. You can define instructions at company, billing account, property and apartment levels; the more specific level overrides the broader one.',
      },
      wizard: {
        superintendent:
          'The superintendent is the person responsible for the daily management and maintenance of the property.',
      },
      condominium: {
        businessId: 'Finnish Business ID in the format 1234567-8. Optional, but recommended for official properties.',
      },
      settings: {
        showMyProperties: 'Show properties where you are listed as superintendent or have special access rights.',
        showBulkDelete:
          'Enable selecting and deleting multiple items in tables (apartments, residents, properties, keys).',
      },
    },
    import: {
      condominiums: 'Properties',
      condominiumsInstructions: 'Import properties',
      apartmentsInstructionsDescription: 'Address and property are mandatory fields.',
      apartmentsFieldCondominium: 'Property: Name of an existing property',
      keysFieldCondominium: 'Property: Name of an existing property (for general keys only)',
      errors: {
        condominiumNotFound: 'Not found',
        condominiumRequiredForGeneral: 'Property is required for general key types',
        condominiumNotAllowedForNonGeneral: 'Property cannot be assigned to non-general key types',
      },
    },
    invitations: {
      condominium: 'Property',
      apartment: 'Apartment',
    },
    contractor: {
      property: 'Property',
      apartment: 'Apartment',
      selectProperty: 'Select property',
      selectApartment: 'Select apartment',
      keyAccessFilterCondominiumPlaceholder: 'All properties',
      keyAccessFilterApartmentPlaceholder: 'All apartments',
    },
    contractorDashboard: {
      properties: 'Properties',
      apartments: 'Apartments',
    },
    documentBank: {
      searchPlaceholder: 'Search properties, apartments, or billing accounts…',
      sections: {
        condominiums: 'Properties',
      },
    },
    events: {
      entityType: {
        resident: 'Resident',
        apartment: 'Apartment',
        condominium: 'Property',
        key: 'Key',
        landlord: 'Landlord',
      },
    },
    reports: {
      totalCondominiums: 'Properties',
    },
    billing: {
      auditCondominium: 'Properties',
      auditApartment: 'Apartments',
      auditResident: 'Residents',
      auditKey: 'Keys',
    },
    landlordPortal: {
      allApartmentsOption: 'All apartments',
    },
    residentNotifications: {
      scope: {
        wholeCondominium: 'Whole property',
      },
      field: {
        wholeCondominium: 'Whole property',
        wholeCondominiumHelp: 'Visible to all apartments under this property in the resident and landlord portals.',
      },
      validation: {
        apartments: 'Select at least one apartment, or choose the whole property.',
      },
    },
    maintenance: {
      needsAssessment: {
        selectCondominium: 'Select property to filter the list.',
      },
    },
    upkeep: {
      selectCondominiums: 'Select properties',
      multiBatchAllApartmentsHelp: 'Creates rows for all apartments in each selected property.',
      filterCondominiums: 'Filter properties',
      filterCondominiumsPlaceholder: 'Enter property name or address',
      sendResidentNotificationHelp:
        'The same notice is sent to residents of the selected properties (and shown in portals).',
      wizardStepLocationHelp:
        'Select the property and apartment if needed. If no apartment is selected, you can choose multiple apartments at once.',
      wizardStepLocationHelpEquipment:
        'Select the property and apartment if needed. If no apartment is selected, choose apartments with devices in the next step.',
      locationProperty: 'Property',
      locationSpace: 'Apartment',
      trackedAssetsEmpty: 'No devices for the selected property',
      noApartmentsForProperty: 'This property has no apartments',
    },
    trackedAssets: {
      columnCondominium: 'Property',
      filterCondominium: 'Filter property',
      selectCondominium: 'Select property',
      mapEmptyHint: 'Link the asset to a property or apartment that has an address.',
      bulkCreateUpkeepSameCondo: 'Select assets from the same property only.',
    },
    residentPortal: {
      filesSectionTitle: 'Apartment and property files',
    },
  },
};
